import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
  MenuItem,
  InputLabel,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { Container, Dropdown, Select } from "semantic-ui-react";

import BGbzu from "assets/images/bg-bzu.png";
import upload from "assets/images/upload-image.png";
import "../student_dashboard/student_dashboard.css";
import Navbar from "../student_dashboard/Components/Navbar";

const StartApplicationForm = () => {
  const { degree } = useParams();
  const query = new URLSearchParams(window.location.search);
  const postIntermediateDegree = query.get("postIntermediateDegree");

  const { organization_id } = useParams();
  const navigate = useNavigate();
  const steps = ["Personal Information", "Academic Details", "Degree"];
  const [currentStep, setCurrentStep] = useState(0);

  // State for form fields
  const [cnic, setCnic] = useState("");
  const [dob, setDob] = useState("");
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [fatherOccupation, setFatherOccupation] = useState("");
  const [fatherCnic, setFatherCnic] = useState("");
  const [gender, setGender] = useState("");
  const [nationality, setNationality] = useState("");
  const [province, setProvince] = useState("");
  const [domicileFile, setDomicileFile] = useState(null);
  const [religion, setReligion] = useState("");
  const [address, setAddress] = useState("");
  const [CurrentAddress, setCurrentAddress] = useState("");
  const [telephone, setTelephone] = useState("");
  const [guardianCell, setGuardianCell] = useState("");
  const [placeOfStay, setPlaceOfStay] = useState("");
  const [hafizQuran, setHafizQuran] = useState(""); // Hafiz-e-Quran
  const [picture, setPicture] = useState(null); // Picture upload
  const [emergencyContact, setEmergencyContact] = useState({
    name: "",
    address: "",
    telephone: "",
    cell: "",
  });
  const [matricDetails, setMatricDetails] = useState({
    degree: "",
    board: "",
    year: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    division: "",
    grade: "",
  });
  const [faDetails, setFaDetails] = useState({
    degree: "",
    board: "",
    year: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    division: "",
    grade: "",
  });
  const [electiveSubjects, setElectiveSubjects] = useState([
    { subject: "", totalMarks: "", obtainedMarks: "" },
    { subject: "", totalMarks: "", obtainedMarks: "" },
    { subject: "", totalMarks: "", obtainedMarks: "" },
  ]);
  const [BsDetails, setBsDetails] = useState({
    Bsdegree: "",
    ExamSystem: "",
    board: "",
    ExamPassin: "",
    year: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    division: "",
    grade: "",
    major: "",
    PositionUni: "",
  });
  const [MaDetails, setMaDetails] = useState({
    degree: "",
    ExamSystem: "",
    board: "",
    ExamPassin: "",
    year: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    division: "",
    grade: "",
    major: "",
    PositionUni: "",
  });
  const [MphilDetails, setMphilDetails] = useState({
    degree: "",
    ExamSystem: "",
    board: "",
    year: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    division: "",
    grade: "",
    PositionUni: "",
  });
  const [bselectiveSubjects, setBselectiveSubjects] = useState([
    { subject: "", totalMarks: "", obtainedMarks: "" },
    { subject: "", totalMarks: "", obtainedMarks: "" },
    { subject: "", totalMarks: "", obtainedMarks: "" },
  ]);
  const [studyEnglish, setStudyEnglish] = useState(""); // Initialize state
  const [gatTests, setGatTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);

  const [publications, setPublications] = useState([]);
  const [selectedPublications, setSelectedPublications] = useState([]);

  // ECAT Test State
  const [ecatDetails, setEcatDetails] = useState({
    attemptTest: "",
    rollNo: "",
    totalMarks: "",
    obtainedMarks: "",
    testDate: "",
  });
  const [formErrors, setFormErrors] = useState({
    cnic: "",
    dob: "",
    name: "",
    fatherName: "",
    fatherOccupation: "",
    fatherCnic: "",
    gender: "",
    nationality: "",
    province: "",
    domicileFile: "",
    religion: "",
    address: "",
    CurrentAddress: "",
    guardianCell: "",
    // placeOfStay: "",
    hafizQuran: "",
    picture: "",
    emergency: {
      name: "",
      address: "",
      cell: "",
    },
    matric: {
      degree: "",
      board: "",
      year: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
      division: "",
      grade: "",
    },
    subjects: {
      subject: "",
      totalMarks: "",
      obtainedMarks: "",
    },
    fa: {
      degree: "",
      board: "",
      year: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
      division: "",
      grade: "",
    },
    BsDetails: {
      Bsdegree: "",
      ExamSystem: "",
      board: "",
      ExamPassin: "",
      year: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
      division: "",
      grade: "",
      major: "",
      PositionUni: "",
    },
    studyEnglish: "",
    bselectiveSubjects: {
      subject: "",
      totalMarks: "",
      obtainedMarks: "",
    },
    MaDetails: {
      degree: "",
      ExamSystem: "",
      board: "",
      ExamPassin: "",
      year: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
      division: "",
      grade: "",
      major: "",
      PositionUni: "",
    },
    gatTests: {
      attemptTest: "",
      testDate: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
    },
    MphilDetails: {
      degree: "",
      ExamSystem: "",
      board: "",
      year: "",
      rollNo: "",
      totalMarks: "",
      obtainedMarks: "",
      division: "",
      grade: "",
      PositionUni: "",
    },
    publications: {
      title: "",
      journalName: "",
      volume: "",
      year: "",
      volume: "",
      issue: "",
      pages: "",
      Recognised: "",
    },
  });

  const handleAddTest = () => {
    setGatTests([
      ...gatTests,
      {
        attemptTest: "",
        testDate: "",
        rollNo: "",
        totalMarks: "",
        obtainedMarks: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const newGatTests = [...gatTests];
    newGatTests[index][field] = value;
    setGatTests(newGatTests);
  };

  const handleSelectTest = (index) => {
    const newSelectedTests = [...selectedTests];
    if (newSelectedTests.includes(index)) {
      newSelectedTests.splice(newSelectedTests.indexOf(index), 1);
    } else {
      newSelectedTests.push(index);
    }
    setSelectedTests(newSelectedTests);
  };

  const handleDeleteSelected = () => {
    const newGatTests = gatTests.filter(
      (_, index) => !selectedTests.includes(index)
    );
    setGatTests(newGatTests);
    setSelectedTests([]); // Clear selection after deletion
  };

  // Pubications

  const handleAddPublication = () => {
    setPublications([
      ...publications,
      {
        title: "",
        journalName: "",
        volume: "",
        year: "",
        volume: "",
        issue: "",
        pages: "",
        // Recognised: "",
      },
    ]);
  };

  const handleChangePublications = (index, field, value) => {
    const newPublications = [...publications];
    newPublications[index][field] = value;
    setPublications(newPublications);
  };

  const handleSelectPublication = (index) => {
    const newSelectedPublications = [...selectedPublications];
    if (newSelectedPublications.includes(index)) {
      newSelectedPublications.splice(newSelectedPublications.indexOf(index), 1);
    } else {
      newSelectedPublications.push(index);
    }
    setSelectedPublications(newSelectedPublications);
  };

  const handleDeleteSelectedPublications = () => {
    const newPublications = publications.filter(
      (_, index) => !selectedPublications.includes(index)
    );
    setPublications(newPublications);
    setSelectedPublications([]); // Clear selection after deletion
  };

  const validateRequiredField = (value, errorMessage) => {
    // Trim value and check if it's empty
    return value && value.trim() === "" ? errorMessage : "";
  };

  const validateYearRange = (year) => {
    const currentYear = new Date().getFullYear();
    return year < 1900 || year > currentYear;
  };

  const validateApplicationForm = () => {
    let errors = {
      emergency: {},
      matric: {},
      fa: {},
      subjects: [],
      BsDetails: {},
      bselectiveSubjects: [],
      MaDetails: {},
      gatTests: {},
      MphilDetails: {},
      publications: {},
    };
    let isValid = true;

    // Function to validate required fields
    const validateRequiredField = (value, fieldName) => {
      if (!value || value.trim() === "") {
        return `* ${fieldName} is required`;
      }
      return null;
    };

    // Step 0 Validation (Personal Information)
    if (currentStep === 0) {
      const fields = [
        { name: "cnic", label: "CNIC" },
        { name: "name", label: "Name" },
        { name: "fatherName", label: "Father's Name" },
        { name: "fatherOccupation", label: "Father's Occupation" },
        { name: "fatherCnic", label: "Father's CNIC" },
        { name: "gender", label: "Gender" },
        { name: "nationality", label: "Nationality" },
        { name: "province", label: "Province" },
        { name: "domicileFile", label: "Domicile" },
        { name: "dob", label: "Date of Birth" },
        { name: "address", label: "Address" },
        { name: "CurrentAddress", label: "Current Address" },
        { name: "guardianCell", label: "Guardian's Cell Number" },
        { name: "hafizQuran", label: "Hafiz-e-Quran" },
        { name: "religion", label: "Religion" },
      ];

      fields.forEach((field) => {
        const value = eval(field.name); // Get value dynamically
        const error = validateRequiredField(value, field.label);
        if (error) {
          errors[field.name] = error;
          isValid = false;
          console.log(error);
        }
      });

      if (!picture) {
        errors.picture = "* Picture is required";
        isValid = false;
        console.log("Picture is required.");
      }

      // Emergency contact validation
      const emergencyFields = [
        { name: "name", label: "Name" },
        { name: "address", label: "Address" },
        { name: "cell", label: "Cell" },
      ];

      emergencyFields.forEach((field) => {
        const value = emergencyContact[field.name];
        const error = validateRequiredField(value, field.label);
        if (error) {
          errors.emergency[field.name] = error;
          isValid = false;
          console.log(error);
        }
      });
    }

    // Step 1 Validation (Matric and FA Details)
    else if (currentStep === 1) {
      // Matric Details
      const matricFields = [
        { name: "degree", label: "Degree" },
        { name: "board", label: "Board" },
        { name: "year", label: "Year" },
        { name: "rollNo", label: "Roll Number" },
        { name: "totalMarks", label: "Total Marks" },
        { name: "obtainedMarks", label: "Obtained Marks" },
        { name: "division", label: "Division" },
        { name: "grade", label: "Grade" },
      ];

      matricFields.forEach((field) => {
        const value = matricDetails[field.name];
        const error = validateRequiredField(value, field.label);
        if (error) {
          errors.matric[field.name] = error;
          isValid = false;
          console.log(error);
        }
      });

      // Year validation for matric
      if (matricDetails.year && validateYearRange(matricDetails.year)) {
        errors.matric.year = "Please enter a valid year.";
        isValid = false;
        console.log("Please enter a valid year for Matric.");
      }

      // F.A Details (Same as Matric)
      const faFields = [
        { name: "degree", label: "Degree" },
        { name: "board", label: "Board" },
        { name: "year", label: "Year" },
        { name: "rollNo", label: "Roll Number" },
        { name: "totalMarks", label: "Total Marks" },
        { name: "obtainedMarks", label: "Obtained Marks" },
        { name: "division", label: "Division" },
        { name: "grade", label: "Grade" },
      ];

      faFields.forEach((field) => {
        const value = faDetails[field.name];
        const error = validateRequiredField(value, field.label);
        if (error) {
          errors.fa[field.name] = error;
          isValid = false;
          console.log(error);
        }
      });

      // Year validation for F.A
      if (faDetails.year && validateYearRange(faDetails.year)) {
        errors.fa.year = "Please enter a valid year.";
        isValid = false;
        console.log("Please enter a valid year for F.A.");
      }

      // Elective Subjects Validation
      electiveSubjects.forEach((subject, index) => {
        const subjectErrors = {};

        subjectErrors.subject = validateRequiredField(
          subject.subject,
          "Subject"
        );
        subjectErrors.totalMarks = validateRequiredField(
          subject.totalMarks,
          "Total Marks"
        );
        subjectErrors.obtainedMarks = validateRequiredField(
          subject.obtainedMarks,
          "Obtained Marks"
        );

        if (
          subject.totalMarks &&
          subject.obtainedMarks &&
          parseInt(subject.obtainedMarks) > parseInt(subject.totalMarks)
        ) {
          subjectErrors.obtainedMarks =
            "Obtained Marks cannot be greater than Total Marks.";
        }

        errors.subjects[index] = subjectErrors; // Ensure errors.subjects is initialized
        if (
          subjectErrors.subject ||
          subjectErrors.totalMarks ||
          subjectErrors.obtainedMarks
        ) {
          console.log(`Subject validation failed at index ${index}`);
        }
      });

      // BsDetails
      if (degree !== "Undergraduate") {
        const BsDetailsFields = [
          { name: "Bsdegree", label: "Degree" },
          { name: "ExamSystem", label: "Exam System" },
          { name: "board", label: "Board" },
          { name: "ExamPassin", label: "Exam Passin" },
          { name: "year", label: "Year" },
          { name: "rollNo", label: "Roll Number" },
          { name: "totalMarks", label: "Total Marks" },
          { name: "obtainedMarks", label: "Obtained Marks" },
          { name: "division", label: "Division" },
          { name: "grade", label: "Grade" },
          // { name: " major", label: "Major" },
          // { name: "PositionUni", label: "Position in University" },
        ];

        // BsDetails Validation
        BsDetailsFields.forEach((field) => {
          const value = BsDetails[field.name]; // Access field value from BsDetails object
          const error = validateRequiredField(value, field.label);
          if (error) {
            errors.BsDetails[field.name] = error;
            isValid = false;
            console.log(error);
          }
        });

        if (
          degree === "M.Phil" &&
          postIntermediateDegree === "BS/B.Sc (Hons)(4 Years)"
        ) {
          if (!BsDetails.major || BsDetails.major.trim() === "") {
            errors.BsDetails.major = "* Major is required for M.Phil.";
            isValid = false;
          }
          if (!BsDetails.PositionUni || BsDetails.PositionUni.trim() === "") {
            errors.BsDetails.PositionUni =
              "* Position in University is required for M.Phil.";
            isValid = false;
          }
        }

        if (degree === "BS 5th Semester") {
          if (!studyEnglish || studyEnglish.trim() === "") {
            errors.studyEnglish = "* Study English field is required.";
            isValid = false;
            console.log("Study English field is required.");
          }

          bselectiveSubjects.forEach((subject, index) => {
            const subjectErrors = {};

            subjectErrors.subject = validateRequiredField(
              subject.subject,
              "Subject"
            );
            subjectErrors.totalMarks = validateRequiredField(
              subject.totalMarks,
              "Total Marks"
            );
            subjectErrors.obtainedMarks = validateRequiredField(
              subject.obtainedMarks,
              "Obtained Marks"
            );

            if (
              subject.totalMarks &&
              subject.obtainedMarks &&
              parseInt(subject.obtainedMarks) > parseInt(subject.totalMarks)
            ) {
              subjectErrors.obtainedMarks =
                "Obtained Marks cannot be greater than Total Marks.";
            }

            if (!errors.bselectiveSubjects) {
              errors.bselectiveSubjects = [];
            }
            errors.bselectiveSubjects[index] = subjectErrors;

            if (
              subjectErrors.subject ||
              subjectErrors.totalMarks ||
              subjectErrors.obtainedMarks
            ) {
              console.log(
                `B Selective Subject validation failed at index ${index}`
              );
            }
          });
        }

        // MA Validations
        if (
          degree === "M.Phil" &&
          postIntermediateDegree === "BA/B.Sc or Equivalent & M.A/M.Sc"
        ) {
          const MaDetailsFields = [
            { name: "degree", label: "Degree" },
            { name: "ExamSystem", label: "Exam System" },
            { name: "board", label: "Board" },
            { name: "ExamPassin", label: "Exam Passin" },
            { name: "year", label: "Year" },
            { name: "rollNo", label: "Roll Number" },
            { name: "totalMarks", label: "Total Marks" },
            { name: "obtainedMarks", label: "Obtained Marks" },
            { name: "division", label: "Division" },
            { name: "grade", label: "Grade" },
            { name: "PositionUni", label: "Position in University" },
          ];

          MaDetailsFields.forEach((field) => {
            const value = MaDetails[field.name];
            const error = validateRequiredField(value, field.label);
            console.log("🚀 ~ BA/B.Sc or Equivalent & M.A/M.Sc ~ isValid:", isValid)

            if (error) {
              errors.MaDetails[field.name] = error;
              isValid = false;
              console.log(error);
            }
          });
        }
      }

      if ((degree === "M.Phil" || degree === "Ph.d") && gatTests.length > 0) {
        const gatTestsFields = [
          { name: "attemptTest", label: "Date" },
          { name: "testDate", label: "Test Date" },
          { name: "rollNo", label: "Roll Number" },
          { name: "totalMarks", label: "Total Marks" },
          { name: "obtainedMarks", label: "Obtained Marks" },
        ];

        gatTests.forEach((gatTestData, index) => {
          console.log(`Processing gatTestData at index ${index}:`, gatTestData);

          // Validate each field for the current gatTestData object
          gatTestsFields.forEach((field) => {
            // Access the value of the field from the current object
            const value = gatTestData[field.name];
            console.log(`Value for ${field.name}:`, value);

            // Validate the field value
            const error = validateRequiredField(value, field.label);
            if (error) {
              // Store the error message in the errors object, organized by array index
              if (!errors.gatTests) errors.gatTests = []; // Initialize as an array if undefined
              if (!errors.gatTests[index]) errors.gatTests[index] = {}; // Initialize an object for the current index

              errors.gatTests[index][field.name] = error;

              // Mark form as invalid
              isValid = false;
            }
          });
        });
      }

      if (degree === "Ph.d") {
        console.log("degree mphil----------");
      
        const MphilDetailsFields = [
          { name: "degree", label: "Degree" },
          { name: "ExamSystem", label: "Exam System" },
          { name: "board", label: "Board" },
          { name: "year", label: "Year" },
          { name: "rollNo", label: "Roll Number" },
          { name: "totalMarks", label: "Total Marks" },
          { name: "obtainedMarks", label: "Obtained Marks" },
          { name: "division", label: "Division" },
          { name: "grade", label: "Grade" },
          { name: "PositionUni", label: "Position in University" },
        ];
      
        if (typeof MphilDetails !== 'undefined') {
          MphilDetailsFields.forEach((field) => {
            // console.log("🚀 ~ MphilDetailsFields.forEach ~ field:", field);
      
            // Check if MphilDetails contains the field's name and log the value
            const value = MphilDetails[field.name];
            console.log(`Value for ${field.name}:`, value); // Log the value of each field
      
            // Validate the value if it's defined
            const error = validateRequiredField(value, field.label);
            // console.log("🚀 ~ MphilDetailsFields.forEach ~ error:", error)
            console.log("🚀 ~ MphilDetailsFields.forEach ~ isValid Test:", isValid)

            
            if (error) {
              errors.MphilDetails[field.name] = error;
              isValid = false;
              console.log(error);
            }
          });
        } else {
          console.log("MphilDetails is not defined or is null.");
        }
      }
      

      if (degree === "Ph.d" && gatTests.length > 0) {
        const publicationsFields = [
          { name: "title", label: "Title" },
          { name: "journalName", label: "Name" },
          { name: "volume", label: "Volume" },
          { name: "issue", label: "Issue" },
          { name: "pages", label: "pages" },
          // { name: "Recognised", label: "Recognised" },
        ];

        publications.forEach((publicationsData, index) => {
          // Validate each field for the current gatTestData object
          publicationsFields.forEach((field) => {
            console.log("Processing field:", field);

            // Access the value of the field from the current object
            const value = publicationsData[field.name];
            console.log(`Value for ${field.name}:`, value);

            // Validate the field value
            const error = validateRequiredField(value, field.label);
            if (error) {
              // Store the error message in the errors object, organized by array index
              if (!errors.publications) errors.publications = []; // Initialize as an array if undefined
              if (!errors.publications[index]) errors.publications[index] = {}; // Initialize an object for the current index

              errors.publications[index][field.name] = error;

              // Mark form as invalid
              isValid = false;

              console.log("Validation error:", error);
            }
          });
        });
      }
    }

    setFormErrors(errors);
    return isValid;
  };

  // Handle next step
  const handleNext = () => {
    const isValid = validateApplicationForm();
    console.log("🚀 ~ handleNext ~ isValid:", isValid);
    if (isValid) {
      setCurrentStep(currentStep + 1);
    }
    
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateApplicationForm();
    if (isValid) {
      navigate("/student-dashboard");
    }
   
  };

  return (
    <PageLayout>
      <Navbar organization_id={organization_id} />
      <Container>
        {/* <div className="title">
          <img src={BGbzu} alt="University Logo" className="logo" />

          <Typography variant="h1">
            BAHAUDDIN ZAKARIYA UNIVERSITY MULTAN
          </Typography>
        </div>
        <Typography variant="h2" className="admission-fall">
          Online Admission System
        </Typography> */}

        {/* <Typography variant="h3">Admission Form</Typography> */}
        {/* <hr className="divider" /> */}
        {/* <p>Post Intermediate Degree: {postIntermediateDegree}</p> */}

        <Stepper activeStep={currentStep} alternativeLabel className="stepper">
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Your form goes here */}
        <form onSubmit={handleSubmit}>
          {currentStep === 0 && (
            <div className="row">
              <div className="p-3">
                <h4 className="applyfor">
                  Apply for: <span className="degreefor">{degree}</span>
                </h4>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>CNIC</label>
                  <input
                    type="text"
                    name="cnic"
                    placeholder="CNIC"
                    value={cnic}
                    onChange={(e) => setCnic(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.cnic}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Date of Birth</label>
                  <input
                    name="date"
                    type="date"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    className="form-control form-control-lg"
                  />
                </div>

                <div className="error-message2">{formErrors.dob}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.name}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Father Name</label>
                  <input
                    type="text"
                    name="fatherName"
                    placeholder="Father's Name"
                    value={fatherName}
                    onChange={(e) => setFatherName(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.fatherName}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Father Occupation</label>
                  <input
                    type="text"
                    name="fatherOccupation"
                    placeholder="Father's Occupation"
                    value={fatherOccupation}
                    onChange={(e) => setFatherOccupation(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">
                  {formErrors.fatherOccupation}
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Father CNIC</label>
                  <input
                    type="text"
                    name="fatherCnic"
                    placeholder="Father's Cnic"
                    value={fatherCnic}
                    onChange={(e) => setFatherCnic(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.fatherCnic}</div>
              </div>

              <div className="col-md-12">
                <div className="form-outline mt-4 mb-4">
                  <div className="gender-align">
                    <label className="gender-label">Gender:</label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Male"
                        checked={gender === "Male"}
                        onChange={(e) => setGender(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Male
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Female"
                        checked={gender === "Female"}
                        onChange={(e) => setGender(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Female
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Transgender"
                        checked={gender === "Transgender"}
                        onChange={(e) => setGender(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Transgender
                    </label>
                  </div>
                </div>

                <div className="error-message2">{formErrors.gender}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Nationality</label>
                  <Select
                    placeholder="Select Nationality"
                    fluid
                    selection
                    value={nationality}
                    onChange={(e, { value }) => setNationality(value)}
                    options={[
                      { key: 1, text: "Pakistani", value: "Pakistani" },
                      { key: 2, text: "Others", value: "Others" },
                    ]}
                    optionLabel="text"
                    optionValue="value"
                    className="form-control form-control-lg"
                  />
                </div>
                <div className="error-message2">{formErrors.nationality}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Province</label>
                  <Select
                    placeholder="Select Province"
                    fluid
                    selection
                    value={province}
                    onChange={(e, { value }) => setProvince(value)}
                    required
                    className="form-control form-control-lg"
                    options={[
                      { key: 1, text: "Punjab", value: "Punjab" },
                      { key: 2, text: "Sindh", value: "Sindh" },
                    ]}
                  />
                </div>
                <div className="error-message2">{formErrors.province}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Domicile</label>
                  <Select
                    placeholder="Select One"
                    fluid
                    selection
                    value={domicileFile}
                    onChange={(e, { value }) => setDomicileFile(value)}
                    required
                    className="form-control form-control-lg"
                    options={[
                      { key: 1, text: "Punjab", value: "Punjab" },
                      { key: 2, text: "Sindh", value: "Sindh" },
                    ]}
                  />
                </div>
                <div className="error-message2">{formErrors.domicileFile}</div>
              </div>

              <div className="col-md-12">
                <div className="form-outline mt-4 mb-4">
                  <div className="gender-align">
                    <label className="gender-label">Religion:</label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Muslim"
                        checked={religion === "Muslim"}
                        onChange={(e) => setReligion(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Muslim
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        value="Non-Muslim"
                        checked={religion === "Non-Muslim"}
                        onChange={(e) => setReligion(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Non-Muslim
                    </label>
                  </div>
                </div>
                <div className="error-message2">{formErrors.religion}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Permanent Address</label>
                  <input
                    type="text"
                    name="address"
                    placeholder="Permanent Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.address}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Current Address</label>
                  <input
                    type="text"
                    name="CurrentAddress"
                    placeholder="Current Address"
                    value={CurrentAddress}
                    onChange={(e) => setCurrentAddress(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.CurrentAddress}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Telephone (PTCL)</label>
                  <input
                    type="text"
                    name="telephone"
                    placeholder="Your Telephone Number"
                    value={telephone}
                    onChange={(e) => setTelephone(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Guardian Cell Number</label>
                  <input
                    type="text"
                    name="guardianCell"
                    placeholder="Guardian's Cell Number"
                    value={guardianCell}
                    onChange={(e) => setGuardianCell(e.target.value)}
                    className="form-control form-control-lg"
                    required
                  />
                </div>

                <div className="error-message2">{formErrors.guardianCell}</div>
              </div>

              <div className="col-md-4">
                <div className="form-outline mt-3">
                  <label>Place of Stay During Study</label>
                  <Select
                    value={placeOfStay}
                    name="placeOfStay"
                    placeholder="Place of Stay"
                    onChange={(e) => setPlaceOfStay(e.target.value)}
                    className="form-control form-control-lg"
                    required
                    options={[
                      { key: 1, text: "Hostel", value: "Hostel" },
                      { key: 2, text: "Other", value: "Other" },
                    ]}
                  />
                </div>
                {/* <div className="error-message2">{formErrors.placeOfStay}</div> */}
              </div>

              <div className="col-md-12">
                <div className="form-outline mt-4 mb-4">
                  <div className="gender-align">
                    <label className="gender-label">Hafiz-e-Quran:</label>
                    <label className="gender-label">
                      <input
                        type="radio"
                        value="Yes"
                        checked={hafizQuran === "Yes"}
                        onChange={(e) => setHafizQuran(e.target.value)}
                        required
                        className="radio-space"
                      />
                      Yes
                    </label>
                    <label className="gender-label">
                      <input
                        type="radio"
                        value="No"
                        checked={hafizQuran === "No"}
                        onChange={(e) => setHafizQuran(e.target.value)}
                        required
                        className="radio-space"
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="error-message2">{formErrors.hafizQuran}</div>
              </div>

              {/* Picture Upload */}
              <div className="col-md-10">
                <div className="form-outline mt-3">
                  <label>Upload Picture</label>
                  <input
                    type="file"
                    onChange={(e) => setPicture(e.target.files[0])}
                    className="form-control form-control-lg uplaod-field"
                    required
                  />
                  <div className="error-message2">{formErrors.picture}</div>

                  <div className="upload-align">
                    <img
                      src={upload}
                      alt="Sample Instructions"
                      className="upload-image"
                    />
                    <div>
                      <h5>Instructions for Upload Picture:</h5>
                      <p>
                        Scan your recent passport size colour photograph taken
                        at a photo studio at 300 dpi. Your application will be
                        rejected if the uploaded photograph does not meet the
                        following requirements:
                      </p>
                      <ul>
                        <li>Your full face must be clearly visible.</li>
                        <li>
                          Background must be plain white, off-white or clear
                          (plain blue is acceptable).
                        </li>
                        <li>
                          The photograph must be scanned clearly and must not be
                          blurry or pixelated.
                        </li>
                        <li>
                          Uploaded photograph must be in JPEG (.jpg) file
                          format.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Emergency Contact Section */}
              <Typography variant="h3" className="sections EmergencyField">
                Person to be Informed in Emergency
              </Typography>
              <div className="row">
                <div className="col-md -4">
                  <div className="form-outline mt-3">
                    <label>Name</label>
                    <input
                      type="text"
                      name="emergencyContactName"
                      placeholder="Emergency Contact Name"
                      value={emergencyContact.name}
                      onChange={(e) =>
                        setEmergencyContact({
                          ...emergencyContact,
                          name: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.emergency.name}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Address</label>
                    <input
                      type="text"
                      name="emergencyContactAddress"
                      placeholder="Emergency Contact Address"
                      value={emergencyContact.address}
                      onChange={(e) =>
                        setEmergencyContact({
                          ...emergencyContact,
                          address: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.emergency.address}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Telephone (PTCL)</label>
                    <input
                      type="text"
                      name="emergencyContactTelephone"
                      placeholder="Emergency Contact Telephone"
                      value={emergencyContact.telephone}
                      onChange={(e) =>
                        setEmergencyContact({
                          ...emergencyContact,
                          telephone: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Cell Number</label>
                    <input
                      type="text"
                      name="emergencyContactCell"
                      placeholder="Emergency Contact Cell Number"
                      value={emergencyContact.cell}
                      onChange={(e) =>
                        setEmergencyContact({
                          ...emergencyContact,
                          cell: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                </div>
                <div className="error-message2">{formErrors.emergency.cell}</div>
              </div>
            </div>
          )}

          {currentStep === 1 && (
            <>
              <Typography variant="h3" className="sections matricField">
                Matric / O Level or Equivalent Detail Section
              </Typography>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Degree</label>
                    <Select
                      placeholder="Select Degree"
                      fluid
                      selection
                      value={matricDetails.degree}
                      onChange={(e, { value }) =>
                        setMatricDetails({ ...matricDetails, degree: value })
                      }
                      options={[
                        {
                          key: 1,
                          text: "Matriculation",
                          value: "Matriculation",
                        },
                        { key: 2, text: "O' Level", value: "O Level" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.matric.degree}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Board Name</label>
                    <Select
                      placeholder="Select Board"
                      fluid
                      selection
                      value={matricDetails.board}
                      onChange={(e, { value }) =>
                        setMatricDetails({ ...matricDetails, board: value })
                      }
                      options={[
                        {
                          key: 1,
                          text: "BISE",
                          value: "BISE",
                        },
                        {
                          key: 2,
                          text: "Cambridge International",
                          value: "Cambridge",
                        },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.matric.board}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Year</label>
                    <input
                      type="number"
                      name="year"
                      placeholder="Year of Passing"
                      value={matricDetails.year}
                      onChange={(e) =>
                        setMatricDetails({
                          ...matricDetails,
                          year: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">{formErrors.matric.year}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Roll No</label>
                    <input
                      type="text"
                      name="rollNo"
                      placeholder="Roll Number"
                      value={matricDetails.rollNo}
                      onChange={(e) =>
                        setMatricDetails({
                          ...matricDetails,
                          rollNo: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.matric.rollNo}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Total Marks</label>
                    <input
                      type=" number"
                      name="totalMarks"
                      placeholder="Total Marks"
                      value={matricDetails.totalMarks}
                      onChange={(e) =>
                        setMatricDetails({
                          ...matricDetails,
                          totalMarks: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.matric.totalMarks}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Obtained Marks</label>
                    <input
                      type="number"
                      name="obtainedMarks"
                      placeholder="Obtained Marks"
                      value={matricDetails.obtainedMarks}
                      onChange={(e) =>
                        setMatricDetails({
                          ...matricDetails,
                          obtainedMarks: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.matric.obtainedMarks}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Division</label>
                    <Select
                      placeholder="Select Division"
                      fluid
                      selection
                      value={matricDetails.division}
                      onChange={(e, { value }) =>
                        setMatricDetails({ ...matricDetails, division: value })
                      }
                      options={[
                        { key: 1, text: "First", value: "First" },
                        { key: 2, text: "Second", value: "Second" },
                        { key: 3, text: "Third", value: "Third" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.matric.division}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Grade</label>
                    <Select
                      placeholder="Select Grade"
                      fluid
                      selection
                      value={matricDetails.grade}
                      onChange={(e, { value }) =>
                        setMatricDetails({ ...matricDetails, grade: value })
                      }
                      options={[
                        { key: 1, text: "A", value: "A" },
                        { key: 2, text: "B", value: "B" },
                        { key: 3, text: "C", value: "C" },
                        { key: 4, text: "D", value: "D" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.matric.grade}</div>
                </div>
              </div>

              <Typography variant="h3" className="sections FaField">
                F.A / F.Sc / ICS / D.Com / DBA / A Level or Equivalent Detail
                (ONLY Part-I marks)
              </Typography>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Degree</label>
                    <Select
                      placeholder="Select Degree"
                      fluid
                      selection
                      value={faDetails.degree}
                      onChange={(e, { value }) =>
                        setFaDetails({ ...faDetails, degree: value })
                      }
                      options={[
                        { key: 1, text: "F.A", value: "F.A" },
                        { key: 2, text: "F.Sc", value: "F.Sc" },
                        { key: 3, text: "ICS", value: "ICS" },
                        { key: 4, text: "D.Com", value: "D.Com" },
                        { key: 5, text: "A' Level", value: "A Level" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.degree}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Board Name</label>
                    <Select
                      placeholder="Select Board"
                      fluid
                      selection
                      value={faDetails.board}
                      onChange={(e, { value }) =>
                        setFaDetails({ ...faDetails, board: value })
                      }
                      options={[
                        {
                          key: 1,
                          text: "BISE",
                          value: "BISE",
                        },
                        {
                          key: 2,
                          text: "Cambridge International",
                          value: "Cambridge",
                        },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.board}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Year</label>
                    <input
                      type="number"
                      name="year"
                      placeholder="Year of Passing"
                      value={faDetails.year}
                      onChange={(e) =>
                        setFaDetails({ ...faDetails, year: e.target.value })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.year}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Roll No</label>
                    <input
                      type="text"
                      name="rollNo"
                      placeholder="Roll Number"
                      value={faDetails.rollNo}
                      onChange={(e) =>
                        setFaDetails({ ...faDetails, rollNo: e.target.value })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.rollNo}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Total Marks</label>
                    <input
                      type="number"
                      name="totalMarks"
                      placeholder="Total Marks"
                      value={faDetails.totalMarks}
                      onChange={(e) =>
                        setFaDetails({
                          ...faDetails,
                          totalMarks: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.fa.totalMarks}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Obtained Marks</label>
                    <input
                      type="number"
                      name="obtainedMarks"
                      placeholder="Obtained Marks"
                      value={faDetails.obtainedMarks}
                      onChange={(e) =>
                        setFaDetails({
                          ...faDetails,
                          obtainedMarks: e.target.value,
                        })
                      }
                      className="form-control form-control-lg"
                      required
                    />
                  </div>
                  <div className="error-message2">
                    {formErrors.fa.obtainedMarks}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Division</label>
                    <Select
                      placeholder="Select Division"
                      fluid
                      selection
                      value={faDetails.division}
                      onChange={(e, { value }) =>
                        setFaDetails({ ...faDetails, division: value })
                      }
                      options={[
                        { key: 1, text: "First", value: "First" },
                        { key: 2, text: "Second", value: "Second" },
                        { key: 3, text: "Third", value: "Third" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.division}</div>
                </div>

                <div className="col-md-4">
                  <div className="form-outline mt-3">
                    <label>Grade</label>
                    <Select
                      placeholder="Select Grade"
                      fluid
                      selection
                      value={faDetails.grade}
                      onChange={(e, { value }) =>
                        setFaDetails({ ...faDetails, grade: value })
                      }
                      options={[
                        { key: 1, text: "A", value: "A" },
                        { key: 2, text: "B", value: "B" },
                        { key: 3, text: "C", value: "C" },
                        { key: 4, text: "D", value: "D" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message2">{formErrors.fa.grade}</div>
                </div>
              </div>

              {/* Elective Subjects */}

              {(degree === "Undergraduate" || degree === "BS 5th Semester") && (
                <>
                  <Typography className="note">
                    If your name is not on the list, please select Other/Not in
                    List
                  </Typography>
                  {electiveSubjects.map((subject, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-4">
                        <div className="form-outline mt-3">
                          <label>Elective Subject {index + 1}</label>
                          <Select
                            placeholder="Select Subject"
                            fluid
                            selection
                            value={subject.subject}
                            onChange={(e, { value }) => {
                              const updatedSubjects = [...electiveSubjects];
                              updatedSubjects[index].subject = value;
                              setElectiveSubjects(updatedSubjects);
                            }}
                            options={[
                              {
                                key: 1,
                                text: "Other/Not in List",
                                value: "Other/Not in List",
                              },
                              { key: 2, text: "Physics", value: "Physics" },
                              { key: 3, text: "Chemistry", value: "Chemistry" },
                              {
                                key: 4,
                                text: "Computer Science",
                                value: "Computer Science",
                              },
                            ]}
                            className="form-control form-control-lg"
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.subjects[index]?.subject}
                        </div>
                      </div>

                      {subject.subject !== "Other/Not in List" && (
                        <>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Subject {index + 1} Total Marks</label>
                              <input
                                type="number"
                                placeholder="Total Marks"
                                value={subject.totalMarks}
                                onChange={(e) => {
                                  const updatedSubjects = [...electiveSubjects];
                                  updatedSubjects[index].totalMarks =
                                    e.target.value;
                                  setElectiveSubjects(updatedSubjects);
                                }}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.subjects[index]?.totalMarks}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Subject {index + 1} Obtained Marks</label>
                              <input
                                type="number"
                                placeholder="Obtained Marks"
                                value={subject.obtainedMarks}
                                onChange={(e) => {
                                  const updatedSubjects = [...electiveSubjects];
                                  updatedSubjects[index].obtainedMarks =
                                    e.target.value;
                                  setElectiveSubjects(updatedSubjects);
                                }}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.subjects[index]?.obtainedMarks}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </>
              )}

              {degree !== "Undergraduate" && (
                <>
                  <Typography variant="h3" className="sections BsField">
                    BS/B.Sc (Hons) (4Years) or Equivalent
                  </Typography>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Degree</label>
                        <Select
                          name="Bsdegree"
                          placeholder="Select Degree"
                          fluid
                          selection
                          value={BsDetails.Bsdegree}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, Bsdegree: value })
                          }
                          options={[
                            { key: 1, text: "MBBS", value: "MBBS" },
                            { key: 2, text: "F.Sc", value: "F.Sc" },
                            { key: 3, text: "ICS", value: "ICS" },
                            { key: 4, text: "D.Com", value: "D.Com" },
                            { key: 5, text: "A' Level", value: "A Level" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.Bsdegree}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Exam System</label>
                        <Select
                          name="ExamSystem"
                          placeholder="Select Board"
                          fluid
                          selection
                          value={BsDetails.ExamSystem}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, ExamSystem: value })
                          }
                          options={[
                            {
                              key: 1,
                              text: "Annual System",
                              value: "Semester System",
                            },
                            {
                              key: 2,
                              text: "Annual System",
                              value: "Semester System",
                            },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.ExamSystem}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Board Name</label>
                        <Select
                          placeholder="Select Board"
                          fluid
                          selection
                          value={BsDetails.board}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, board: value })
                          }
                          options={[
                            {
                              key: 1,
                              text: "BISE",
                              value: "BISE",
                            },
                            {
                              key: 2,
                              text: "Cambridge International",
                              value: "Cambridge",
                            },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.board}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Exam Pass in</label>
                        <Select
                          placeholder="Select One"
                          fluid
                          selection
                          value={BsDetails.ExamPassin}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, ExamPassin: value })
                          }
                          options={[
                            {
                              key: 1,
                              text: "Annual",
                              value: "Annual",
                            },
                            {
                              key: 2,
                              text: "Supply",
                              value: "Supply",
                            },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.ExamPassin}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Year</label>
                        <input
                          type="number"
                          name="year"
                          placeholder="Year of Passing"
                          value={BsDetails.year}
                          onChange={(e) =>
                            setBsDetails({ ...BsDetails, year: e.target.value })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.year}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Roll No</label>
                        <input
                          type="text"
                          name="rollNo"
                          placeholder="Roll Number"
                          value={BsDetails.rollNo}
                          onChange={(e) =>
                            setBsDetails({
                              ...BsDetails,
                              rollNo: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.rollNo}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Total Marks</label>
                        <input
                          type="number"
                          name="totalMarks"
                          placeholder="Total Marks"
                          value={BsDetails.totalMarks}
                          onChange={(e) =>
                            setBsDetails({
                              ...BsDetails,
                              totalMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.totalMarks}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Obtained Marks</label>
                        <input
                          type="number"
                          name="obtainedMarks"
                          placeholder="Obtained Marks"
                          value={BsDetails.obtainedMarks}
                          onChange={(e) =>
                            setBsDetails({
                              ...BsDetails,
                              obtainedMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.obtainedMarks}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Grade</label>
                        <Select
                          placeholder="Select Grade"
                          fluid
                          selection
                          value={BsDetails.grade}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, grade: value })
                          }
                          options={[
                            { key: 1, text: "A", value: "A" },
                            { key: 2, text: "B", value: "B" },
                            { key: 3, text: "C", value: "C" },
                            { key: 4, text: "D", value: "D" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.grade}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Division</label>
                        <Select
                          placeholder="Select Division"
                          fluid
                          selection
                          value={BsDetails.division}
                          onChange={(e, { value }) =>
                            setBsDetails({ ...BsDetails, division: value })
                          }
                          options={[
                            { key: 1, text: "First", value: "First" },
                            { key: 2, text: "Second", value: "Second" },
                            { key: 3, text: "Third", value: "Third" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.BsDetails.division}
                      </div>
                    </div>

                    {degree === "BS 5th Semester" && (
                      <>
                        <Typography className="note">
                          If your name is not on the list, please select
                          Other/Not in List
                        </Typography>
                        <div className="row">
                          <div className="col-md-11">
                            <div className="form-outline mt-3">
                              <label>Study English</label>
                              <Select
                                placeholder="Select One"
                                fluid
                                selection
                                value={studyEnglish}
                                onChange={(e, { value }) => {
                                  setStudyEnglish(value);
                                }}
                                options={[
                                  { key: 1, text: "Yes", value: "Yes" },
                                  { key: 2, text: "No", value: "No" },
                                ]}
                                className="uplaod-field form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.studyEnglish}
                            </div>
                          </div>

                          {bselectiveSubjects.map((subject, index) => (
                            <div className="row" key={index}>
                              <div className="col-md-4">
                                <div className="form-outline mt-3">
                                  <label>Elective Subject {index + 1}</label>
                                  <Select
                                    placeholder="Select Subject"
                                    fluid
                                    selection
                                    value={subject.subject}
                                    onChange={(e, { value }) => {
                                      const updatedSubjects = [
                                        ...bselectiveSubjects,
                                      ];
                                      updatedSubjects[index].subject = value;

                                      // Reset Total Marks and Obtained Marks if "Other/Not in List" is selected
                                      if (value === "Other/Not in List") {
                                        updatedSubjects[index].totalMarks = "";
                                        updatedSubjects[index].obtainedMarks =
                                          "";
                                      }

                                      setBselectiveSubjects(updatedSubjects);
                                    }}
                                    options={[
                                      {
                                        key: 1,
                                        text: "Other/Not in List",
                                        value: "Other/Not in List",
                                      },
                                      {
                                        key: 2,
                                        text: "Statistics",
                                        value: "Statistics",
                                      },
                                      {
                                        key: 3,
                                        text: "Geography",
                                        value: "Geography",
                                      },
                                      {
                                        key: 4,
                                        text: "Environmental Science",
                                        value: "Environmental Science",
                                      },
                                    ]}
                                    className="form-control form-control-lg"
                                  />
                                </div>
                                <div className="error-message2">
                                  {
                                    formErrors.bselectiveSubjects[index]
                                      ?.subject
                                  }
                                </div>
                              </div>

                              {/* Conditionally render Total Marks if not "Other/Not in List" */}
                              {subject.subject !== "Other/Not in List" && (
                                <>
                                  <div className="col-md-4">
                                    <div className="form-outline mt-3">
                                      <label>
                                        Subject {index + 1} Total Marks
                                      </label>
                                      <input
                                        type="number"
                                        placeholder="Total Marks"
                                        value={subject.totalMarks}
                                        onChange={(e) => {
                                          const updatedSubjects = [
                                            ...bselectiveSubjects,
                                          ];
                                          updatedSubjects[index].totalMarks =
                                            e.target.value;
                                          setBselectiveSubjects(
                                            updatedSubjects
                                          );
                                        }}
                                        className="form-control form-control-lg"
                                        required
                                      />
                                    </div>
                                    <div className="error-message2">
                                      {
                                        formErrors.bselectiveSubjects[index]
                                          ?.totalMarks
                                      }
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-outline mt-3">
                                      <label>
                                        Subject {index + 1} Obtained Marks
                                      </label>
                                      <input
                                        type="number"
                                        placeholder="Obtained Marks"
                                        value={subject.obtainedMarks}
                                        onChange={(e) => {
                                          const updatedSubjects = [
                                            ...bselectiveSubjects,
                                          ];
                                          updatedSubjects[index].obtainedMarks =
                                            e.target.value;
                                          setBselectiveSubjects(
                                            updatedSubjects
                                          );
                                        }}
                                        className="form-control form-control-lg"
                                        required
                                      />
                                    </div>
                                    <div className="error-message2">
                                      {
                                        formErrors.bselectiveSubjects[index]
                                          ?.obtainedMarks
                                      }
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {degree === "M.Phil" &&
                      postIntermediateDegree === "BS/B.Sc (Hons)(4 Years)" && (
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Major/Specialization</label>
                              <Select
                                placeholder="Select One"
                                fluid
                                selection
                                value={BsDetails.major}
                                onChange={(e, { value }) =>
                                  setBsDetails({ ...BsDetails, major: value })
                                }
                                options={[
                                  {
                                    key: 1,
                                    text: "Marketing",
                                    value: "Marketing",
                                  },
                                  { key: 2, text: "HRM", value: "HRM" },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.BsDetails.major}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Position in University</label>
                              <Select
                                placeholder="Select One"
                                fluid
                                selection
                                value={BsDetails.PositionUni}
                                onChange={(e, { value }) =>
                                  setBsDetails({
                                    ...BsDetails,
                                    PositionUni: value,
                                  })
                                }
                                options={[
                                  { key: 1, text: "No", value: "No" },
                                  { key: 2, text: "1st", value: "1st" },
                                  { key: 3, text: "2nd", value: "2nd" },
                                  { key: 4, text: "3rd", value: "3rd" },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.BsDetails.PositionUni}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  {degree === "M.Phil" &&
                    postIntermediateDegree ===
                      "BA/B.Sc or Equivalent & M.A/M.Sc" && (
                      <>
                        <Typography variant="h3" className="sections MaField">
                          M.A/M.Sc or Equivalent
                        </Typography>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Degree</label>
                              <Select
                                placeholder="Select Degree"
                                fluid
                                selection
                                value={MaDetails.degree}
                                onChange={(e, { value }) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    degree: value,
                                  })
                                }
                                options={[
                                  { key: 1, text: "MBBS", value: "MBBS" },
                                  { key: 2, text: "F.Sc", value: "F.Sc" },
                                  { key: 3, text: "ICS", value: "ICS" },
                                  { key: 4, text: "D.Com", value: "D.Com" },
                                  {
                                    key: 5,
                                    text: "A' Level",
                                    value: "A Level",
                                  },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.degree}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Exam System</label>
                              <Select
                                placeholder="Select Board"
                                fluid
                                selection
                                value={MaDetails.ExamSystem}
                                onChange={(e, { value }) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    ExamSystem: value,
                                  })
                                }
                                options={[
                                  {
                                    key: 1,
                                    text: "Annual System",
                                    value: "Semester System",
                                  },
                                  {
                                    key: 2,
                                    text: "Annual System",
                                    value: "Semester System",
                                  },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.ExamSystem}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Board Name</label>
                              <Select
                                placeholder="Select Board"
                                fluid
                                selection
                                value={MaDetails.board}
                                onChange={(e, { value }) =>
                                  setMaDetails({ ...MaDetails, board: value })
                                }
                                options={[
                                  {
                                    key: 1,
                                    text: "BISE",
                                    value: "BISE",
                                  },
                                  {
                                    key: 2,
                                    text: "Cambridge International",
                                    value: "Cambridge",
                                  },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.board}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Exam Pass in</label>
                              <Select
                                placeholder="Select One"
                                fluid
                                selection
                                value={MaDetails.board}
                                onChange={(e, { value }) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    ExamPassin: value,
                                  })
                                }
                                options={[
                                  {
                                    key: 1,
                                    text: "Annual",
                                    value: "Annual",
                                  },
                                  {
                                    key: 2,
                                    text: "Supply",
                                    value: "Supply",
                                  },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.ExamPassin}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Year</label>
                              <input
                                type="number"
                                name="year"
                                placeholder="Year of Passing"
                                value={MaDetails.year}
                                onChange={(e) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    year: e.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.year}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Roll No</label>
                              <input
                                type="text"
                                name="rollNo"
                                placeholder="Roll Number"
                                value={MaDetails.rollNo}
                                onChange={(e) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    rollNo: e.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.rollNo}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Total Marks</label>
                              <input
                                type="number"
                                name="totalMarks"
                                placeholder="Total Marks"
                                value={MaDetails.totalMarks}
                                onChange={(e) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    totalMarks: e.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.totalMarks}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Obtained Marks</label>
                              <input
                                type="number"
                                name="obtainedMarks"
                                placeholder="Obtained Marks"
                                value={MaDetails.obtainedMarks}
                                onChange={(e) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    obtainedMarks: e.target.value,
                                  })
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.obtainedMarks}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Grade</label>
                              <Select
                                placeholder="Select Grade"
                                fluid
                                selection
                                value={MaDetails.grade}
                                onChange={(e, { value }) =>
                                  setMaDetails({ ...MaDetails, grade: value })
                                }
                                options={[
                                  { key: 1, text: "A", value: "A" },
                                  { key: 2, text: "B", value: "B" },
                                  { key: 3, text: "C", value: "C" },
                                  { key: 4, text: "D", value: "D" },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.grade}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Division</label>
                              <Select
                                placeholder="Select Division"
                                fluid
                                selection
                                value={MaDetails.division}
                                onChange={(e, { value }) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    division: value,
                                  })
                                }
                                options={[
                                  { key: 1, text: "First", value: "First" },
                                  { key: 2, text: "Second", value: "Second" },
                                  { key: 3, text: "Third", value: "Third" },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.division}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Position in University</label>
                              <Select
                                placeholder="Select One"
                                fluid
                                selection
                                value={MaDetails.PositionUni}
                                onChange={(e, { value }) =>
                                  setMaDetails({
                                    ...MaDetails,
                                    PositionUni: value,
                                  })
                                }
                                options={[
                                  { key: 1, text: "No", value: "No" },
                                  { key: 2, text: "1st", value: "1st" },
                                  { key: 3, text: "2nd", value: "2nd" },
                                  { key: 4, text: "3rd", value: "3rd" },
                                ]}
                                className="form-control form-control-lg"
                              />
                            </div>
                            <div className="error-message2">
                              {formErrors.MaDetails.PositionUni}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </>
              )}

              {degree === "Ph.d" && (
                <>
                  <Typography variant="h3" className="sections MphilField">
                    M.Phil Detail
                  </Typography>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Degree</label>
                        <Select
                          placeholder="Select Degree"
                          fluid
                          selection
                          value={MphilDetails.degree}
                          onChange={(e, { value }) =>
                            setMphilDetails({
                              ...MphilDetails,
                              degree: value,
                            })
                          }
                          options={[
                            { key: 1, text: "MBBS", value: "MBBS" },
                            { key: 2, text: "F.Sc", value: "F.Sc" },
                            { key: 3, text: "ICS", value: "ICS" },
                            { key: 4, text: "D.Com", value: "D.Com" },
                            { key: 5, text: "A' Level", value: "A Level" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.degree}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Exam System</label>
                        <Select
                          placeholder="Select Board"
                          fluid
                          selection
                          value={MphilDetails.ExamSystem}
                          onChange={(e, { value }) =>
                            setMphilDetails({
                              ...MphilDetails,
                              ExamSystem: value,
                            })
                          }
                          options={[
                            {
                              key: 1,
                              text: "Annual System",
                              value: "Semester System",
                            },
                            {
                              key: 2,
                              text: "Annual System",
                              value: "Semester System",
                            },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.ExamSystem}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Board Name</label>
                        <Select
                          placeholder="Select Board"
                          fluid
                          selection
                          value={MphilDetails.board}
                          onChange={(e, { value }) =>
                            setMphilDetails({ ...MphilDetails, board: value })
                          }
                          options={[
                            {
                              key: 1,
                              text: "BISE",
                              value: "BISE",
                            },
                            {
                              key: 2,
                              text: "Cambridge International",
                              value: "Cambridge",
                            },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.board}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Year</label>
                        <input
                          type="number"
                          name="year"
                          placeholder="Year of Passing"
                          value={MphilDetails.year}
                          onChange={(e) =>
                            setMphilDetails({
                              ...MphilDetails,
                              year: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.year}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Roll No</label>
                        <input
                          type="text"
                          name="rollNo"
                          placeholder="Roll Number"
                          value={MphilDetails.rollNo}
                          onChange={(e) =>
                            setMphilDetails({
                              ...MphilDetails,
                              rollNo: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.rollNo}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Total Marks</label>
                        <input
                          type="number"
                          name="totalMarks"
                          placeholder="Total Marks"
                          value={MphilDetails.totalMarks}
                          onChange={(e) =>
                            setMphilDetails({
                              ...MphilDetails,
                              totalMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.totalMarks}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Obtained Marks</label>
                        <input
                          type="number"
                          name="obtainedMarks"
                          placeholder="Obtained Marks"
                          value={MphilDetails.obtainedMarks}
                          onChange={(e) =>
                            setMphilDetails({
                              ...MphilDetails,
                              obtainedMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.obtainedMarks}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Grade</label>
                        <Select
                          placeholder="Select Grade"
                          fluid
                          selection
                          value={MphilDetails.grade}
                          onChange={(e, { value }) =>
                            setMphilDetails({ ...MphilDetails, grade: value })
                          }
                          options={[
                            { key: 1, text: "A", value: "A" },
                            { key: 2, text: "B", value: "B" },
                            { key: 3, text: "C", value: "C" },
                            { key: 4, text: "D", value: "D" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.grade}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Division</label>
                        <Select
                          placeholder="Select Division"
                          fluid
                          selection
                          value={MphilDetails.division}
                          onChange={(e, { value }) =>
                            setMphilDetails({
                              ...MphilDetails,
                              division: value,
                            })
                          }
                          options={[
                            { key: 1, text: "First", value: "First" },
                            { key: 2, text: "Second", value: "Second" },
                            { key: 3, text: "Third", value: "Third" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.division}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Position in University</label>
                        <Select
                          placeholder="Select One"
                          fluid
                          selection
                          value={MphilDetails.PositionUni}
                          onChange={(e, { value }) =>
                            setMphilDetails({
                              ...MphilDetails,
                              PositionUni: value,
                            })
                          }
                          options={[
                            { key: 1, text: "No", value: "No" },
                            { key: 2, text: "1st", value: "1st" },
                            { key: 3, text: "2nd", value: "2nd" },
                            { key: 4, text: "3rd", value: "3rd" },
                          ]}
                          className="form-control form-control-lg"
                        />
                      </div>
                      <div className="error-message2">
                        {formErrors.MphilDetails.PositionUni}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ECAT Test Details */}
              {degree === "Undergraduate" && (
                <div>
                  <Typography variant="h3" className="sections EcatTest">
                    ECAT Test Detail (If available)
                  </Typography>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-outline mt-4 mb-4">
                        <div className="gender-align">
                          <label className="gender-label">
                            Do you want to attempt the university engineering
                            test?
                          </label>
                          <label className="gender-label">
                            <input
                              type="radio"
                              value="Yes"
                              checked={ecatDetails.attemptTest === "Yes"}
                              onChange={(e) =>
                                setEcatDetails({
                                  ...ecatDetails,
                                  attemptTest: e.target.value,
                                })
                              }
                              required
                              className="radio-space"
                            />
                            Yes
                          </label>
                          <label className="gender-label">
                            <input
                              type="radio"
                              value="No"
                              checked={ecatDetails.attemptTest === "No"}
                              onChange={(e) =>
                                setEcatDetails({
                                  ...ecatDetails,
                                  attemptTest: e.target.value,
                                })
                              }
                              required
                              className="radio-space"
                            />
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Roll No</label>
                        <input
                          type="text"
                          placeholder="Roll Number"
                          value={ecatDetails.rollNo}
                          onChange={(e) =>
                            setEcatDetails({
                              ...ecatDetails,
                              rollNo: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Test Total Marks</label>
                        <input
                          type="number"
                          placeholder="Total Marks"
                          value={ecatDetails.totalMarks}
                          onChange={(e) =>
                            setEcatDetails({
                              ...ecatDetails,
                              totalMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>Test Obtained Marks</label>
                        <input
                          type="number"
                          placeholder="Obtained Marks"
                          value={ecatDetails.obtainedMarks}
                          onChange={(e) =>
                            setEcatDetails({
                              ...ecatDetails,
                              obtainedMarks: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-outline mt-3">
                        <label>ECAT Test Date</label>
                        <input
                          type="date"
                          value={ecatDetails.testDate}
                          onChange={(e) =>
                            setEcatDetails({
                              ...ecatDetails,
                              testDate: e.target.value,
                            })
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {degree === "M.Phil" || degree === "Ph.d" ? (
                <div>
                  <Typography variant="h3" className="sections gatTest">
                    GAT Test Details
                  </Typography>

                  {gatTests.map((gatTest, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-12 mt-3">
                        <input
                          type="checkbox"
                          checked={selectedTests.includes(index)}
                          onChange={() => handleSelectTest(index)}
                        />
                        <label className="label-check">Select for delete</label>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>GAT Test</label>
                          <Select
                            placeholder="Select One"
                            fluid
                            selection
                            value={gatTest.attemptTest}
                            onChange={(e, { value }) =>
                              handleChange(index, "attemptTest", value)
                            }
                            options={[
                              {
                                key: 1,
                                text: "Computer Engineering",
                                value: "Computer Engineering",
                              },
                              { key: 2, text: "Chemistry", value: "Chemistry" },
                            ]}
                            className="form-control form-control-lg"
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.gatTests.attemptTest}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Valid Till</label>
                          <input
                            type="date"
                            value={gatTest.testDate}
                            onChange={(e) =>
                              handleChange(index, "testDate", e.target.value)
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.gatTests.testDate}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Roll No</label>
                          <input
                            type="text"
                            placeholder="Roll Number"
                            value={gatTest.rollNo}
                            onChange={(e) =>
                              handleChange(index, "rollNo", e.target.value)
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.gatTests.rollNo}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Total Marks</label>
                          <input
                            type="number"
                            placeholder="Total Marks"
                            value={gatTest.totalMarks}
                            onChange={(e) =>
                              handleChange(index, "totalMarks", e.target.value)
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.gatTests.totalMarks}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Obtained Marks</label>
                          <input
                            type="number"
                            placeholder="Obtained Marks"
                            value={gatTest.obtainedMarks}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "obtainedMarks",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.gatTests.obtainedMarks}
                        </div>
                      </div>
                    </div>
                  ))}

                  <button onClick={handleAddTest} className="btn-gat mt-3">
                    Add
                  </button>

                  <button
                    onClick={handleDeleteSelected}
                    className="btn-gat mt-3"
                  >
                    Delete
                  </button>
                </div>
              ) : null}

              {degree === "Ph.d" && (
                <div>
                  <Typography variant="h3" className="sections publicTest">
                    Publications
                  </Typography>
                  <Typography className="note2">
                    Detail/Copy of Publication/Article must be submitted to
                    department concerned at the time of test, Failing which
                    agregate/marks will not be considered for merit calculation.{" "}
                  </Typography>
                  {publications.map((publication, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-12 mt-3">
                        <input
                          type="checkbox"
                          checked={selectedPublications.includes(index)}
                          onChange={() => handleSelectPublication(index)}
                        />
                        <label className="label-check">Select for delete</label>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Title of Article</label>
                          <input
                            type="text"
                            placeholder="Title of Article"
                            value={publication.title}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "title",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.title}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Name of Journal</label>
                          <input
                            type="text"
                            placeholder="Enter Journal Name"
                            value={publication.journalName}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "journalName",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.journalName}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Year of Publication</label>
                          <input
                            type="number"
                            placeholder="e.g. 2018"
                            value={publication.year}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "year",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                            min="1900"
                            max={new Date().getFullYear()}
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.year}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Volume</label>
                          <input
                            type="text"
                            placeholder="Enter Volume"
                            value={publication.volume}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "volume",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.volume}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Issue</label>
                          <input
                            type="text"
                            placeholder="Enter Page Range"
                            value={publication.issue}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "issue",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.issue}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Pages</label>
                          <input
                            type="text"
                            placeholder="Enter Page Range"
                            value={publication.pages}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "pages",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message2">
                          {formErrors.publications.pages}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-outline mt-3">
                          <label>Recognised</label>
                          <Select
                            placeholder="Select One"
                            fluid
                            selection
                            value={publication.Recognised}
                            onChange={(e) =>
                              handleChangePublications(
                                index,
                                "Recognised",
                                e.target.value
                              )
                            }
                            options={[
                              {
                                key: 1,
                                text: "Yes",
                                value: "Yes",
                              },
                              { key: 2, text: "No", value: "No" },
                            ]}
                            className="form-control form-control-lg"
                          />
                        </div>
                        {/* <div className="error-message2">{formErrors.publications.Recognised}</div> */}
                      </div>
                    </div>
                  ))}

                  <button
                    onClick={handleAddPublication}
                    className="btn-gat mt-3"
                  >
                    Add
                  </button>

                  <button
                    onClick={handleDeleteSelectedPublications}
                    className="btn-gat mt-3"
                  >
                    Delete
                  </button>
                </div>
              )}
            </>
          )}

          {currentStep === 2 && (
            <div>
              {/* New field */}
              <div className="row">Degree Assign</div>
            </div>
          )}

          <div className="navigation-buttons">
            {currentStep > 0 && (
              <Button
                type="button"
                onClick={handleBack}
                className="btn btn-secondary mt-5 mb-4"
              >
                Back
              </Button>
            )}

            {currentStep < steps.length - 1 && (
              <Button
                type="button"
                onClick={handleNext}
                className="secondary mt-5 mb-4"
              >
                Next
              </Button>
            )}

            {currentStep === steps.length - 1 && (
              <Button type="submit" className="secondary mt-5 mb-4">
                Submit
              </Button>
            )}
          </div>
        </form>
      </Container>
    </PageLayout>
  );
};

export default StartApplicationForm;
